import { IconShape, SectionElement } from "@wuilt/section-preview";
import { nanoid } from "nanoid";
import {
  OldSocialLinkValue,
  SocialLinkSettingsExtended,
} from "./social-links-types";

function migrateSettings(
  id: string,
  old: OldSocialLinkValue | SocialLinkSettingsExtended
): SocialLinkSettingsExtended {
  // has been migrated before
  if ((old as SocialLinkSettingsExtended).iconStyle)
    return old as SocialLinkSettingsExtended;

  const castedOld = old as OldSocialLinkValue;

  return {
    id: id,
    hidden: false,
    iconStyle: { color: "#1d2939", shape: IconShape.Filled, size: "30" },
    socialLinks: Object.keys(castedOld).map((social) => ({
      id: `SocialIcon:${nanoid()}`,
      name: social,
      link: castedOld[social],
    })),
  };
}

export function migrateElement(
  id: string,
  old: OldSocialLinkValue
): SectionElement & {
  settings: SocialLinkSettingsExtended;
} {
  const settings = migrateSettings(id, old);

  return { id: id || `SocialLinks:${nanoid()}`, type: "SocialLinks", settings };
}
